/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronRightAboveDoubleLine: {
  name: 'chevron-right-above-double-line';
  data: string;
} = {
  name: 'chevron-right-above-double-line',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.293 12.707a1 1 0 0 1 0-1.414L12.586 8 9.293 4.707a1 1 0 0 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0ZM7 16a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8Z" fill="currentColor"/></svg>`,
};
